module.exports = __webpack_public_path__ + "img/LF005-07.14085f43.jpg";